import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Password-Strength-H" }
const _hoisted_2 = { class: "App-Password-Feed" }
const _hoisted_3 = { "mute-primary": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["App-Password-Strength", _ctx.result.value])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass((_ctx.isTooWeak || _ctx.isWeak || _ctx.isMedium || _ctx.isStrong).toString())
        }, null, 2)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass((_ctx.isWeak || _ctx.isMedium || _ctx.isStrong).toString())
        }, null, 2)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass((_ctx.isMedium || _ctx.isStrong).toString())
        }, null, 2)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.isStrong.toString())
        }, null, 2)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("small", _hoisted_3, _toDisplayString(_ctx.result.value), 1)
    ])
  ]))
}